import { IDanhSachKhongDuDieuKienThucTapActionTypes } from "../../action-types/xet-thuc-tap/IDanhSachKhongDuDieuKienThucTapActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachKhongDuDieuKienThucTapReducer } from "../../reducer-model/xet-thuc-tap/IDanhSachKhongDuDieuKienThucTapReducer";

const iniState : IDanhSachKhongDuDieuKienThucTapReducer = {
    status: eReducerStatusBase.is_not_initialization,
    danhSachKhongDuDieuKienThucTaps: [],
    danhSachKhongDuDieuKienChiTietDiem: {
        danhSachKhongDuDieuKiens: [],
        diemXets: []
    },
}

export const danhSachKhongDuDieuKienThucTapReducer = (state: IDanhSachKhongDuDieuKienThucTapReducer = iniState, action: IDanhSachKhongDuDieuKienThucTapActionTypes): IDanhSachKhongDuDieuKienThucTapReducer => {
    switch (action.type) {
        case "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachKhongDuDieuKienThucTaps: action.payload
            };
        case "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachKhongDuDieuKienChiTietDiem: action.payload,
            };
        case "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP_LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
};